import { useTranslation } from 'react-i18next';
import type { StaticSharedField } from './types';
import {
  ERR_TYPE_REQUIRED,
  ERR_TYPE_STR_LONG,
  ERR_TYPE_STR_SHORT,
  FIELD_TYPE_TXT,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useMakeSupplierName({
  label,
  propName,
}: {
  label?: string;
  propName?: string;
}): StaticSharedField {
  const { t } = useTranslation();

  return {
    type: FIELD_TYPE_TXT,
    label: label || 'Supplier name:',
    element: 'customer_supplier_name',
    propName: propName || 'customer_supplier_name',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOSUPPLIERNAME',
        errStr: t('business:Errors.supplierForm.supplierName'),
      },
      {
        rule: ERR_TYPE_STR_SHORT,
        errCode: 'ERRSUPPLIERNAMETOOSHORT',
        errStr: t('business:Errors.supplierForm.supplierName'),
        value: 3,
      },
      {
        rule: ERR_TYPE_STR_LONG,
        errCode: 'ERRSUPPLIERNAMETOOLONG',
        errStr: t('business:Errors.supplierForm.supplierName'),
        value: 300,
      },
    ],
  };
}
